import styled from 'styled-components';

export const SpotContainer = styled.div`
  position: relative;
  width: ${(props): number => props['data-size']}px;
  height: ${(props): number => props['data-size']}px;
`;

export const FavIconContainer = styled.div`
  position: absolute;
  z-index: 10;
  right: -10%;
  bottom: -10%;
  width: ${(props): number => props['data-size']}px;
  height: ${(props): number => props['data-size']}px;
`;
